<template>
  <div class="header">
    <div class="logo-container">
      <a href="https://www.futech-tools.com/" target="_blank">
        <img src="/assets/img/logo.png">
      </a>
    </div>
    <div class="language-picker">
      <button v-if="appPage === 'app-screen-splash'" v-for="language in languageList" @click="setLanguage(language.short)" class="language-picker" :class="{active: language.short === currentLanguage}">{{ language.short }}</button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { mapActions } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        currentLanguage: 'getLanguage',
        languageList: 'getLanguageList',
        appPage: 'navigation/getAppPage',
      }),
    },
    methods: {
      ...mapActions({
        fetchLanguages: 'fetchLanguages',
        setLanguage: 'setLanguage',
      }),
    },
    created() {
      this.fetchLanguages();
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/LanguageList.vue